<template>
	<div id="sre-intro">
		<div class="box">
			<h2>平台简介</h2>
			<p>维图云管平台致力于为用户提供“多快好省”的多云治理能力，主要功能包含跨云管理、自服务、自动化运维和成本管理优化。</p>
			<div class="item">
				<img src="../assets/images/weitu-1.png" width="32%" />
				<div class="content right">
					<h3>多云管理</h3>
					<p>集中纳管各类公有云资源，支持阿里云、京东云、微软云等主流公有云平台，帮助企业自由选择云平台，摆脱云依赖。未来，维图还将支持多种私有云资源的纳管，全方位实现云平台中立。支持一键导入公有云、私有云资源，帮助用户实现跨云统一管理异构资源。</p>
				</div>
			</div>
			<div class="item">
				<div class="content left">
					<h3>自服务</h3>
					<p>管理员自定义基础资源和应用服务目录供内部消费者（一般指开发人员）自助申请使用，实现自主快速获取资源，提高面向公司最终客户的服务交付速度。</p>
				</div>
				<img src="../assets/images/weitu-2.png" width="36%" />
			</div>
			<div class="item">
				<img src="../assets/images/weitu-3.png" width="37%" />
				<div class="content right">
					<h3>自动化</h3>
					<p>提供基于事件驱动的自动化运维能力，通过监测定时器、WebHook 等事件触发来执行“工具”，在多云环境下实现应用部署、服务管理、系统巡检等自动化运维场景。</p>
				</div>
			</div>
			<div class="item">
				<div class="content left">
					<h3>成本中心</h3>
					<p>监管多云成本开支，提供成本可视化分析，动态分析资源利用率并结合各云厂商资费套餐情况，从降配、释放资源、更换套餐等方面及时提出优化建议，为用户管好每一笔云开支，降低用云成本。</p>
				</div>
				<img src="../assets/images/weitu-4.png" width="32%" />
			</div>
		</div>
		<div class="decoration">
			<div class="outer-circle">
				<div class="inner-circle"></div>
			</div>
			<div class="divider"></div>
			<div class="outer-circle">
				<div class="inner-circle"></div>
			</div>
			<div class="divider"></div>
			<div class="outer-circle">
				<div class="inner-circle"></div>
			</div>
			<div class="divider"></div>
			<div class="outer-circle">
				<div class="inner-circle"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'SreIntro'
	}
</script>

<style>
	#sre-intro {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		background-color: #F1F7FF;
	}

	#sre-intro .box {
		position: relative;
		width: 53%;
		/* height: 1873px; */
		margin: 75px 0 80px 0;
	}

	#sre-intro .box h2 {
		font-size: 36px;
		font-family: SimHei;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
	}

	#sre-intro .box p {
		font-size: 18px;
		font-family: SimHei;
		font-weight: 400;
		color: rgba(68, 68, 68, 1);
		margin-top: 38px;
	}

	#sre-intro .decoration {
		width: 100%;
		height: 1258px;
		position: absolute;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		margin-top: 388px;
	}

	#sre-intro .decoration .outer-circle {
		width: 28px;
		height: 28px;
		background: rgba(238, 245, 253, 0);
		border: 2px solid #00F4FF;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	#sre-intro .decoration .inner-circle {
		width: 16px;
		height: 16px;
		background: linear-gradient(0deg, rgba(0, 211, 221, 1) 0%, rgba(0, 244, 255, 1) 100%);
		border-radius: 50%;
	}

	#sre-intro .decoration .divider {
		width: 2px;
		height: 382px;
		background-color: #00F4FF;
	}

	#sre-intro .box .item {
		width: 100%;
		height: 350px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-top: 63px;
	}

	#sre-intro .box .item .content {
		width: 39%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}

	#sre-intro .box .item .content.right {
		margin-left: 27%;
	}

	#sre-intro .box .item .content.left {
		margin-right: 21%;
	}

	#sre-intro .box .item h3 {
		font-size: 30px;
		font-family: SimHei;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
	}

	#sre-intro .box .item p {
		width: 100%;
		font-size: 18px;
		font-family: SimHei;
		font-weight: 400;
		color: rgba(68, 68, 68, 1);
		line-height: 38px;
		text-align: left;
		margin-top: 36px;
	}

	@media(max-width:992px) {
		#sre-intro .box {
			width: 95%;
			/* height: 1873px; */
			margin: 35px 10px 40px 10px;
		}

		#sre-intro .box h2 {
			font-size: 0.2rem;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
		}

		#sre-intro .box p {
			font-size: 0.12rem;
			line-height: 1.1;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(68, 68, 68, 1);
			margin-top: 0.28rem;
			text-align: center;
		}

		#sre-intro .decoration {
			display: none;
		}

		#sre-intro .box .item {
			width: 100%;
			height: 120px;
			display: flex;
			justify-content: space-around;
			align-items: center;
			margin-top: 0.33rem;
		}

		#sre-intro .box .item img {
			width: 30%;
		}

		#sre-intro .box .item .content {
			width: 40%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
		}

		#sre-intro .box .item .content.right {
			margin-left: 0;
		}

		#sre-intro .box .item .content.left {
			margin-right: 0;
		}

		#sre-intro .box .item h3 {
			font-size: 0.16rem;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
		}

		#sre-intro .box .item p {
			width: 100%;
			font-size: 0.12rem;
			font-family: SimHei;
			font-weight: 400;
			color: rgba(68, 68, 68, 1);
			line-height: 1.1;
			text-align: left;
			margin-top: 0.12rem;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SreIntro.vue